import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { LanguageSelector } from './LanguageSelector';
import { GithubIcon, LinkedinIcon } from './icons';

export const Header: React.FC = () => {
  const { t } = useTranslation();
  const [currentTime, setCurrentTime] = useState('');

  useEffect(() => {
    const updateTime = () => {
      const now = new Date();
      setCurrentTime(
        now.toLocaleTimeString('pt-BR', { hour12: false, timeZone: 'America/Sao_Paulo' }) + ' BRT'
      );
    };
    updateTime();
    const timer = setInterval(updateTime, 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <header className="sticky top-0 z-50 backdrop-blur-md bg-[#07090E]/80 border-b border-[#00F0FF]/15">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between font-mono text-xs tracking-wider">
        <div className="flex items-center space-x-3">
          <span className="relative flex h-2 w-2">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#00F0FF] opacity-75"></span>
            <span className="relative inline-flex rounded-full h-2 w-2 bg-[#00F0FF]"></span>
          </span>
          <span className="text-[#00F0FF] font-bold">{t('header.name')}</span>
          <span className="text-gray-600">//</span>
          <span className="text-gray-400 hidden sm:inline">{t('header.title')}</span>
        </div>

        <div className="flex items-center space-x-4 sm:space-x-6 text-gray-400">
          <div className="hidden md:flex items-center space-x-2 border border-gray-800 bg-[#0C0E14] px-3 py-1 rounded-sm">
            <span className="text-gray-500">{t('header.timeLabel')}</span>
            <span className="text-gray-200">{currentTime || '12:00:00 BRT'}</span>
          </div>

          <LanguageSelector />

          <div className="flex items-center space-x-3">
            <a 
              href="https://github.com/luanyata" 
              target="_blank" 
              rel="noreferrer"
              className="hover:text-[#00F0FF] transition-colors p-1"
              title="GitHub"
            >
              <GithubIcon size={16} />
            </a>
            <a 
              href="https://www.linkedin.com/in/luanyata/" 
              target="_blank" 
              rel="noreferrer"
              className="hover:text-[#00F0FF] transition-colors p-1"
              title="LinkedIn"
            >
              <LinkedinIcon size={16} />
            </a>
          </div>
        </div>
      </div>
    </header>
  );
};
